import { useTranslation } from "react-i18next";
import { BackgroundSelection } from "./Background/BackgroundSelection";
import styles from "./NewScene.module.scss";

interface Props {
	handleSaveForm: () => void;
};

const NewScene: React.FC<Props> = ({ handleSaveForm }) => {
	const { t } = useTranslation('form');
	return (
		<div className={styles.sceneContainer}>
			<BackgroundSelection />
			<button className={`${styles.saveButton}`} onClick={handleSaveForm}>
				{t("save")}
			</button>
		</div>
	);
};

export default NewScene;
